import { FlowOperationType, isNil } from '@activepieces/shared';
import { Trash } from 'lucide-react';
import React, { useState } from 'react';

import { useBuilderStateContext } from '../../builder-hooks';
import { flowUtilConsts } from '../utils/consts';
import { ApButtonData } from '../utils/types';

import { cn } from '@/lib/utils';

const ApDetachButton = (props: ApButtonData) => {
  const [readonly, applyOperation] = useBuilderStateContext((state) => [
    state.readonly,
    state.applyOperation,
  ]);

  const connection = props.connection;

  if (readonly || isNil(connection)) {
    return null;
  }

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    applyOperation(
      {
        type: FlowOperationType.DETACH_STEPS,
        request: {
          connection,
        },
      },
      () => {
        console.error('Detach operation failed');
      },
    );
  };

  return (
    <div
      style={{
        width: flowUtilConsts.AP_NODE_SIZE.ADD_BUTTON.width + 'px',
        height: flowUtilConsts.AP_NODE_SIZE.ADD_BUTTON.height + 'px',
      }}
    >
      <div
        onClick={handleClick}
        style={{
          width: flowUtilConsts.AP_NODE_SIZE.ADD_BUTTON.width + 'px',
          height: flowUtilConsts.AP_NODE_SIZE.ADD_BUTTON.height + 'px',
        }}
        className={cn('rounded-xss cursor-pointer transition-all z-50')}
      >
        <div
          style={{
            width: flowUtilConsts.AP_NODE_SIZE.ADD_BUTTON.width + 'px',
            height: flowUtilConsts.AP_NODE_SIZE.ADD_BUTTON.height + 'px',
          }}
          className={cn(
            'bg-light-blue relative group overflow-visible rounded-xss cursor-pointer flex items-center justify-center transition-all duration-300 ease-in-out',
          )}
        >
          <Trash className="w-3 h-3 stroke-[3px] text-white" />
        </div>
      </div>
    </div>
  );
};
ApDetachButton.displayName = 'ApDetachButton';
export { ApDetachButton };
